// قاموس ثابت لمصطلحات الأقسام — بدون AI. يُعالج "ال"/"و"/الجمع/الهمزات تلقائيًا.

const PHRASES = {
  "قسم المبيعات والتسويق": "Sales & Marketing Department", "قسم المبيعات": "Sales Department",
  "قسم المشتريات": "Purchases Department", "قسم المخازن": "Warehouse Department",
  "قسم المخزون": "Inventory Department", "قسم الموارد البشرية": "Human Resources Department",
  "قسم المحاسبة": "Accounting Department", "قسم المالية": "Finance Department",
  "قسم تقنيات المعلومات": "IT Department", "قسم تقنية المعلومات": "IT Department",
  "قسم العمليات": "Operations Department", "قسم الإنتاج": "Production Department",
  "قسم الجودة": "Quality Department", "قسم الصيانة": "Maintenance Department",
  "قسم الشحن والتوصيل": "Shipping & Delivery Department", "قسم خدمة العملاء": "Customer Service Department",
  "قسم الأبحاث والتطوير": "R&D Department", "الأبحاث والتطوير": "Research & Development", "قسم البحث والتطوير": "R&D Department", "البحث والتطوير": "Research & Development",
  "تقنيات المعلومات": "Information Technology", "تقنية المعلومات": "Information Technology",
  "الموارد البشرية": "Human Resources", "الإدارة العامة": "General Administration",
  "خدمة العملاء": "Customer Service", "العلاقات العامة": "Public Relations",
};

const WORDS = {
  "قسم": "Department", "إدارة": "Administration", "المبيعات": "Sales",
  "المشتريات": "Purchases", "المخازن": "Warehouse", "المخزون": "Inventory",
  "الموارد": "Resources", "البشرية": "Human", "المحاسبة": "Accounting",
  "المالية": "Finance", "الإدارة": "Administration", "العمليات": "Operations",
  "الإنتاج": "Production", "الجودة": "Quality", "الصيانة": "Maintenance",
  "الأمن": "Security", "الخدمات": "Services", "التصميم": "Design",
  "التطوير": "Development", "البحث": "Research", "التوصيل": "Delivery",
  "الشحن": "Shipping", "اللوجستيات": "Logistics", "الاستشارات": "Consulting",
  "الفوترة": "Billing", "الدعم": "Support", "المشاريع": "Projects",
  "الشراء": "Procurement", "التوريد": "Supply", "الخزينة": "Treasury",
  "القانوني": "Legal", "القانونية": "Legal", "الطبي": "Medical",
  "الهندسة": "Engineering", "التدريب": "Training", "التوظيف": "Recruitment",
  "الحضور": "Attendance", "الرواتب": "Payroll", "الأرشيف": "Archives",
  "التقنية": "Technology", "المعلومات": "Information", "التسويق": "Marketing",
  "العلاقات": "Relations", "العملاء": "Customers", "خدمة": "Service",
  "العامة": "General", "العام": "General", "الشركة": "Company",
  "المكتب": "Office", "الرئيسي": "Main", "المستودع": "Warehouse",
  "المصنع": "Factory", "التنفيذي": "Executive", "المخاطر": "Risk",
  "التخطيط": "Planning", "الميزانية": "Budget", "الحسابات": "Accounts",
  "الفواتير": "Invoicing", "الرقابة": "Audit", "الابتكار": "Innovation",
  "الاتصالات": "Communications", "الأبحاث": "Research", "المتاجر": "Stores",
  "الفروع": "Branches", "التعليم": "Education", "و": "and",
  "في": "in", "من": "of", "على": "on", "بيت": "House",
};

const _n = (s) => (s || "").replace(/[أإآ]/g, "ا").replace(/ى/g, "ي");
const _W = Object.fromEntries(Object.keys(WORDS).map((k) => [_n(k), WORDS[k]]));
const _P = Object.fromEntries(Object.keys(PHRASES).map((k) => [_n(k), PHRASES[k]]));
const _L = (w) => WORDS[w] || _W[_n(w)];

function translateWord(w) {
  if (!w) return null;
  const direct = _L(w);
  if (direct) return direct;
  if (w.startsWith("و") && w.length > 1) {
    const t = _L(w.slice(1)) || _L("ال" + w.slice(1));
    if (t) return `and ${t}`;
  }
  if (w.startsWith("ال") && w.length > 2) { const t = _L(w.slice(2)); if (t) return t; }
  if (w.endsWith("ات") && w.length > 3) {
    const t = _L(w.slice(0, -2) + "ة") || _L("ال" + w.slice(0, -2) + "ة");
    if (t) return t;
  }
  const bare = _L("ال" + w); if (bare) return bare;
  return null;
}

export function deriveEnglish(ar) {
  if (!ar || !ar.trim()) return "";
  const text = ar.trim();
  const ph = PHRASES[text] || _P[_n(text)];
  if (ph) return ph;
  const parts = text.split(/(\s+|[،.,;:])/);
  const out = parts.map((p) => {
    if (/^\s+$/.test(p) || /^[،.,;:]$/.test(p)) return p === "،" ? "," : p;
    return translateWord(p) || "";
  });
  const joined = out.join(" ").replace(/\s+/g, " ").replace(/\s+,/g, ",").trim();
  return joined.replace(/^and\s+/i, "").replace(/\s+and\s*$/i, "").replace(/^Department\s+(.+)$/i, "$1 Department");
}

const R_PHRASES = Object.fromEntries(Object.entries(PHRASES).map(([k, v]) => [v.toLowerCase(), k]));
const R_WORDS = {};
Object.entries(WORDS).forEach(([k, v]) => { const e = v.toLowerCase(); if (!R_WORDS[e]) R_WORDS[e] = k; });

export function deriveArabic(en) {
  if (!en || !en.trim()) return "";
  const t = en.trim();
  if (R_PHRASES[t.toLowerCase()]) return R_PHRASES[t.toLowerCase()];
  const parts = t.replace(/&/g, " and ").split(/\s+/).filter(Boolean);
  const out = [];
  for (let i = 0; i < parts.length; i++) {
    const lp = parts[i].toLowerCase();
    if (lp === "and" && i + 1 < parts.length) {
      const nx = R_WORDS[parts[i + 1].toLowerCase()];
      if (nx) { out.push("و" + nx); i += 1; continue; }
    }
    out.push(R_WORDS[lp] || parts[i]);
  }
  return out.join(" ").trim();
}
